<script>
import TotalData from './TotalData'
import Charts from './Charts'
import IncomeChart from '@/components/income/IncomeChart'
export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  components: {
    Charts,
    TotalData,
    IncomeChart,
  },
  data() {
    return {
      record: null,
      filter_period: '',
      filter_days: '',
    }
  },
  mounted() {
    this.fetchRecord()
  },
  methods: {
    fetchRecord() {
      this.$axios.get(`applications/${this.id}/detail`).then((res) => {
        this.record = res.data
      })
    },
  },
}
</script>

<template>
  <div class="row w-100" v-if="record !== null">
    <b-tabs pills justified content-class="p-3 text-muted w-100">
      <b-tab>
        <template v-slot:title>
          جزئیات اپلیکیشن
        </template>
        <div class="row w-100">
          <div class="col-12 px-0">
            <div class="card">
              <div class="card-body">
                <table class="table table-nowrap mb-0 w-100">
                  <tbody>
                    <tr>
                      <th scope="row" style="width: 400px;">نام اپلیکیشن</th>
                      <td>{{ record.name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">آیکن</th>
                      <td>
                        <img
                          :src="record.logoAddress"
                          style="max-height: 100px"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">نام پکیج اندروید</th>
                      <td>{{ record.pkgNameAndroid }}</td>
                    </tr>
                    <tr>
                      <th scope="row">نام پکیج IOS</th>
                      <td>{{ record.pkgNameIos }}</td>
                    </tr>
                    <tr>
                      <th scope="row">جهت نمایش</th>
                      <td>{{ record.orientation_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">رده سنی</th>
                      <td>{{ record.sen }} الی {{ record.senEnd }}</td>
                    </tr>
                    <tr>
                      <th scope="row">نام ورژن</th>
                      <td>{{ record.versionName }}</td>
                    </tr>
                    <tr>
                      <th scope="row">لینک اپلیکیشن</th>
                      <td>
                        <a
                          v-if="record.appLink"
                          :href="record.appLink"
                          target="_blank"
                          >مشاهده</a
                        >
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">تاریخ ثبت</th>
                      <td>{{ record.addedDate }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab>
        <template v-slot:title>اطلاعات آماری</template>
        <div class="row px-0 mx-auto">
          <total-data :record="record" />
          <income-chart
            class="w-100"
            :application_id="id"
            :title="`درآمد اپلیکیشن ${record.name}`"
          />
          <Charts :record="record" />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<style>
.tabs {
  width: 100%;
}
</style>
